import { Tooltip } from "react-bootstrap";

export const getTooltip = (text) => {
  if (!text) return <i />;
  return <Tooltip id="ol-p1">{text}</Tooltip>;
};
